import Text from "components/Text";
import { FC, useState } from "react";
import { BiUser } from "react-icons/bi";
import { AdressProps } from "../ContactCard";
import { InfoTabsWrapper, Tab, Tabs } from "./InfoTabs.styled";
import PersonalInfo from "./PersonalInfo";

export const InfoTabs: FC<{ addressInfo: AdressProps }> = ({ addressInfo }) => {
    const [selectedTab, setSelectedTab] = useState("");

    const handleTabSelection = (tab: string) => {
        if (tab === selectedTab) {
            setSelectedTab("");
        } else {
            setSelectedTab(tab);
        }
    };
    return (
        <InfoTabsWrapper>
            <Tabs>
                <Tab
                    isSelected={selectedTab === "Company Info"}
                    onClick={() => handleTabSelection("Company Info")}
                >
                    <BiUser />
                    <Text variant="label">Company Info</Text>
                </Tab>
            </Tabs>
            {(selectedTab === "Company Info" || selectedTab === "") && (
                <PersonalInfo addressInfo={addressInfo} />
            )}
        </InfoTabsWrapper>
    );
};
